import "babel-polyfill";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import { addTranslation, initialize } from "react-localize-redux";
import { Provider } from "react-redux";
import "react-select/dist/react-select.css";
import WebFont from "webfontloader";
import { languages } from "./configs/Settings";
import configureStore from "./redux/configureStore";
import { refreshToken } from "./redux/modules/Auth";
import registerServiceWorker from "./registerServiceWorker";
import translations from "./resources/Translations";
import "./scss/main.css";
import App from "./views/App";

console.log = () => {
  return null;
}; //disable console log completely

WebFont.load({
  google: {
    families: ["Montserrat:300,500,600,700", "sans-serif"]
  }
});

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

//Init multiple languages
store.dispatch(initialize(languages));
store.dispatch(addTranslation(translations));

//refresh and validate token
store.dispatch(refreshToken());

const rootElement = document.getElementById("root");

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  rootElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js